import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

const cookieconsent = window.initCookieConsent();
if (
  cookieconsent.allowedCategory("performance") &&
  process.env.NODE_ENV !== "development"
) {
  (async () => {
    const LogRocket = await import("logrocket");
    const setupLogRocketReact = await import("logrocket-react");
    LogRocket.init("9a2ec1/hr-go-recruitment");
    setupLogRocketReact(LogRocket);
  })();
}

ReactDOM.render(<App />, document.getElementById("client-dashboard-app-root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
